
import CtPhoneVerify from '@/components/phoneVerify/index.vue'
import { samsungI18nConfig } from '@/utils/const'
import { mapState } from 'vuex'
export default {
  components: {
    CtPhoneVerify,
  },
  props: {
    waybillNo: {
      type: String,
    },
    cusId: {
      type: String,
    },
    route: {
      type: Object,
      default: () => ({}),
    },
    timeOptions: {
      type: Array,
      default: () => [],
    },
    mobile: {
      type: String,
      default: '',
    },
    records: {
      type: Object,
      default: () => {},
    },
    isSelecting: {
      type: Boolean,
      default: true,
    },
    // 区号
    curPhoneCode: {
      type: String,
      default: '',
    },
    // 验证码
    validateCode: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState({
      initTimeZone: (state) => state.support.initTimeZone,
      site: (state) => state.site,
    }),
    getTimeOptions() {
      return this.timeOptions.map((item) => {
        return {
          value: item.day,
          label: `${item.day} ${item.week}`,
        }
      })
    },
    isTimeChecked() {
      return this.selectType === 'time'
    },
    isTimeShow() {
      return this.isTimeChecked
    },
    // process(){
    //   return this.isSelecting
    // }
    customerType() {
      return this.$route.query.customer_type || ''
    },
    channel() {
      return this.customerType === 'samsung' ? 2 : 3
    },
    isSgSite() {
      return this.site.toUpperCase() === 'SG'
    },
  },
  // watch: {
  //   initTimeZone(val) {
  //     console.log('initTimeZone--时区', val);
  //     if (val) this.curTimeZone = val
  //   },
  // },
  data() {
    return {
      showCancelReservation: false,
      visible: false,
      selectType: 'time',
      timeRadio: '',
      process: true,
    }
  },
  mounted() {
    // this.init()
    // console.log('initTimeZone--时区333',this.initTimeZone);
    // console.log('isSelecting', this.isSelecting);
    // 编辑时 获取之前预约的日期时间
    if (!this.isSelecting) {
      this.timeRadio = this.records?.extendInfo?.deliveryTime
    }
  },
  methods: {
    handleChange(item) {
      this.timeRadio = item.value
    },
    // 获取签收时间或者预计送达时间
    getFinalTime(route) {
      const flag = this.isSigned(route)
      if (flag && route?.barNewList?.length > 0) {
        const item = route?.barNewList[0]
        return item.barScanDt + ' ' + item.barScanTm
      } else {
        return route?.pisDeliveryTm?.queryPromise || ''
      }
    },
    // 是否已签收
    isSigned(route) {
      return route?.barNewList?.some((item) => item.opCodeStatus === 'signed') || false
    },
    previousPage() {
      this.$emit('previousPage')
    },
    async handleOk() {
      // this.showCancelReservation = false
      const params = {
        // cusId: this.records.cusId,
        cusId: this.cusId,
        waybillNo: this.waybillNo,
        phoneCode: this.curPhoneCode, // 区号
        validateCode: this.validateCode, // 验证码
        verifiedPhoneNumber: this.mobile, // 手机号
        channel: this.channel,
      }
      // this.trackFn()
      const res = await this.$API.support.cancelDirectiveApi(params)
      if (res?.success) {
        //取消预约成功
        // this.$toast({
        //   message: this.$t(
        //     'serviceSupport.querySupport.waybills.successCancelAppointment'
        //   ),
        // })
        // this.$router.go(-1)
        this.$message.success(
          this.$t(
            'serviceSupport.querySupport.waybills.successCancelAppointment'
          )
        )
        this.showCancelReservation = false
        this.previousPage()
      } else {
        //取消预约失败
        // res?.msg &&
        //   this.$toast({
        //     message: res?.msg,
        //   })
        res?.msg &&
          this.$message.error(
            this.$t(
              'serviceSupport.querySupport.waybills.successCancelAppointment'
            )
          )
      }
    },
    handleCancel() {
      this.showCancelReservation = false
    },
    // 反脱敏数据
    async getDecodeData(params = {}, cap = {}) {
      const { customer_type: customerType } = this.$route.query
      if (customerType === 'samsung') {
        params.customer_type = customerType
      }
      const result = await this.$API.support.billRouteApi(params, cap)
      if (result && result.length) {
        this.visible = false
        this.$emit('decode', result)
      }
    },
    async handleConfirm() {
      const params = {
        requirementTel: this.mobile, // 需求方联系方式
        waybillNo: this.waybillNo, // 运单号
        channel: this.channel,
        phoneCode: this.curPhoneCode,
        validateCode: this.validateCode, // 验证码
        verifiedPhoneNumber: this.mobile, // 手机号
      }
      // if (this.channel === 2) {
      //   params.customerType = this.customerType
      // }

      if (this.isTimeChecked) {
        params.serviceCode = samsungI18nConfig.type2.serviceCode
        params.deliveryDate = this.timeRadio //预约时间(serviceCode为7时传预约的日期,)
      } else {
        params.serviceCode = samsungI18nConfig.type1.serviceCode
        //serviceCode为5时传当日日期
        params.deliveryDate = formatTimeWithMoment(new Date(), 'yyyy-MM-DD')
      }

      // this.trackFn('query')
      try {
        const res = await this.$API.support.submitDirectiveApi(params)
        if (res?.records?.length > 0 && res.records[0].directiveStatus === 1) {
          // 预约成功
          // this.$toast({
          //   message: this.$t(
          //     'serviceSupport.querySupport.waybills.successAppointment'
          //   ),
          // })
          // this.trackFn('success')
          this.$message.success(
            this.$t('serviceSupport.querySupport.waybills.successAppointment')
          )
          // this.$router.go(-1)
          this.isSelecting = false
          this.cusId = res.records[0].cusId
          console.log('预约成功后---cusId', this.cusId)
          // this.timeRadio =
          // this.previousPage();
        } else {
          // 预约失败
          // res?.msg &&
          //   this.$toast({
          //     message: res?.msg,
          //   })
          res?.msg && this.$message.error(res?.msg)
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 反脱敏数据
    async getDecodeData(params = {}, cap = {}) {
      const { customer_type: customerType } = this.$route.query
      if (customerType === 'samsung') {
        params.customer_type = customerType
      }
      const result = await this.$API.support.billRouteApi(params, cap)
      if (result && result.length) {
        this.visible = false
        this.route.sourceCityName = result[0].sourceCityName
        this.route.destCityName = result[0].destCityName
        this.route.isDecode = true
        // this.$emit('decode', result)
      }
    },
    getReDecode(waybillNo) {
      this.route.isDecode = false
      this.route.sourceCityName = '***'
      this.route.destCityName = '***'
    },
  },
}
